import React from "react";
import "../assets/css/company.css"
function Company () {
    return (
        <>
        <div className="company-page">
            
        </div>

        </>
    )
    
}
export default Company;